import { Button, buttonVariants } from "@takt/web-ui/components/button"
import { Card } from "@takt/web-ui/components/card"
import { TaktMark } from "@takt/web-ui/components/takt-mark"
import { createRootRoute, Link, Outlet } from "@tanstack/react-router"

function ErrorView({ error }: { error: unknown }) {
    const message = error instanceof Error ? error.message : "An unexpected error occurred."

    return (
        <main className="admin-grid grid min-h-screen place-items-center p-6">
            <Card className="w-full max-w-md p-6 text-center">
                <TaktMark className="mx-auto" size="lg" variant="beat" />
                <h1 className="mt-5 text-xl font-bold">Groomio Admin could not load</h1>
                <p className="mt-2 text-sm text-muted-foreground">{message || "An unexpected error occurred."}</p>
                <Button className="mt-5 w-full" onClick={() => window.location.reload()}>
                    Refresh
                </Button>
            </Card>
        </main>
    )
}

export const Route = createRootRoute({
    component: Outlet,
    errorComponent: ({ error }) => <ErrorView error={error} />,
    notFoundComponent: () => (
        <main className="admin-grid grid min-h-screen place-items-center p-6">
            <Card className="w-full max-w-md p-6 text-center">
                <p className="text-sm font-semibold text-primary">404</p>
                <h1 className="mt-2 text-xl font-bold">Page not found</h1>
                <p className="mt-2 text-sm text-muted-foreground">The Admin page you requested does not exist.</p>
                <Link to="/dashboard" className={buttonVariants({ className: "mt-5 w-full no-underline" })}>
                    Go to dashboard
                </Link>
            </Card>
        </main>
    ),
})
